export const enum CONSTANTE_CONSENTS_RECHAZADOS_TELEFONO {
  TELEFONO_AUTO_LEASING = '900 50 64 85',
  TELEFONO_CONSUMO = '902 88 60 07',
  TELEFONO_BONPREU = '93 151 43 43',
  TELEFONO_MANGO = '91 111 60 97',
  TELEFONO_TODAY = '91 210 48 25',
  TELEFONO_REPSOL = '902 09 07 91',
  TELEFONO_CG = '902 10 20 07',
  TELEFONO_CE_CD_CF = '902 88 60 07',
}

export const enum FINANCIAL_PRODUCT {
  CONSTANTE_PRODUCTO_FINANCIERO_LEASING = '40',
  CONSTANTE_PRODUCTO_FINANCIERO_AUTOS = '20',
  CONSTANTE_PRODUCTO_FINANCIERO_CONSUMO = '10',
  CONSTANTE_PRODUCTO_FINANCIERO_PRESTAMOS = '15',
  CONSTANTE_PRODUCTO_FINANCIERO_TARJETAS = '30',
}

export const enum CONSTANTE_MARCA {
  MANGO = 'MG',
  BONPREU = 'BP',
  TODAY = 'TO',
  REPSOL = 'RE',
  CUENTA_GASOLEO = 'CG',
  CUENTA_DEPORTES = 'CD',
  CE = 'CE',
  CF = 'CF',
}

export const LOGALTY_STATE_REFUSED = '8';
export const LOGALTY_STATE_REFUSED_INTERVENER = '10006';
export const LOGALTY_STATE_CANCELED = '99904';
//WE GOT THIS HTTPSTATUS FROM BACK WHEN USER ALREADY SIGNED IN ASYNC
export const HTTP_STATUS_ERROR_ALREADY_SIGNED = 417;
